export const NEWADMIN = 'NEWADMIN';
export const DELETEADMIN = 'DELETEADMIN';
export const UPDATEADMIN = 'UPDATEADMIN';
export const ADMINDATA = 'ADMINDATA';
export const ONEADMINDATA = 'ONEADMINDATA';
export const SHOW_LOADING = 'SHOW_LOADING'